import { CONFIG } from '../../core/config';
import { EquipmentFunctionModelSearchResult } from './equipment-function-model-search-result';
import { EquipmentFunctionModelSelectionCriteriaBase } from './equipment-function-model-selection-criteria-base';

export class EquipmentFunctionModelSelectionCriteria extends EquipmentFunctionModelSelectionCriteriaBase {
  friendlyTypeNameSingular: string = 'Equipment Function Model Selection Criteria';
  apiRoute: string = CONFIG.apiRoutes.equipmentFunctionModelSelection;

  searchResult: EquipmentFunctionModelSearchResult = new EquipmentFunctionModelSearchResult();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);

    this.searchResult = new EquipmentFunctionModelSearchResult();
    if (data.searchResult) {
      this.searchResult.loadFromJson(data.searchResult);
    }
  }

  hasModel(): boolean {
    return this.searchResult && this.searchResult.foundModel;
  }

  modelName(): string {
    return this.searchResult.foundModel ? this.searchResult.modelName : EquipmentFunctionModelSelectionCriteriaBase.unfoundModelName;
  }
}
